<template>
  <v-card style="min-height: 100vh" class="bg-light" elevation="0">
    <v-app-bar outlined short color="#ffffff" elevation="0.5">
      <v-icon @click="back()">mdi-arrow-left</v-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title
        align-self="center"
        class="text-button font-weight-6 grey--text text--darken-2 p-0 m-0"
      >
        Rewards
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-sheet
      height="calc(100vh - 48px)"
      color="#f3f3f3"
      :class="`${ isLoggedIn ? '' : 'pb-56' } overflow-y-auto p-0`"
    >
      <v-card flat class="m-3" v-if="rewards.length === 0">
        <v-list color="#ffffff">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title
                style="font-size: 12px !important"
                class="text-caption text-center font-weight-bold mt-2"
              >
                No reward found
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
      <div v-else>
        <v-card flat class="mx-3 mt-3">
          <v-list color="#ffffff">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title
                  class="text-body-2 text-center font-weight-6"
                >
                  You have <span class="h4 font-weight-bold tertiary--text mx-1">{{ pointBalance }}</span> pts
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
        <v-sheet 
          ref="reward-sheet"
          class="reward-sheet mt-6 p-2"
          color="transparent"
          elevation="0"
        >
          <v-row no-gutters>
            <v-col
              class="mb-4"
              cols="6"
              :key="`reward-${reward.id}`"
              v-for="(reward, index) in rewards"
            >
              <v-card
                color="#efe6df"
                class="rounded-xl p-2"
                :class="{
                  'ml-2': index % 2 == 1,
                  'mr-2': index % 2 == 0,
                }"
                elevation="0"
                @click="requestRedeemLoyaltyReward(reward)"
              >
                <v-img
                  class="rounded-xl"
                  position="center"
                  height="150"
                  :src="`${cdnUrl}/${reward.cover}`"
                ></v-img>
                <v-card-title class="reward-code text-caption font-weight-bold p-2">{{ reward.code }}</v-card-title>
                <v-card-subtitle class="text-center mt-1 py-0 px-2">
                  <!-- <v-chip
                    small
                    class="mr-1 my-1 chip-service"
                    v-if="reward.delivery"
                    >Delivery</v-chip
                  >
                  <v-chip
                    small
                    class="mr-1 my-1 chip-service"
                    v-if="reward.pickup"
                    >Pickup</v-chip
                  >
                  <v-chip
                    small
                    class="mr-1 my-1 chip-service"
                    v-if="reward.dinein"
                    >Dine In</v-chip
                  >
                  <span
                    class="font-weight-bold"
                    style="font-size:10px; color:#757575"
                    v-if="reward.dinein"
                  >
                    * Redeem at Cashier *
                  </span>
                  -->
                </v-card-subtitle>
                <v-card-actions class="p-0">
                  <v-row class="px-5">
                    <v-col cols="8" class="text-left p-0">
                      <span class="text-caption tertiary--text font-weight-bold">
                        {{ reward.points }} pts
                      </span>
                    </v-col>
                    <v-col cols="4" class="text-right p-0">
                      <v-btn
                        class="text-caption text-capitalize justify-content-end font-weight-bold px-0"
                        color="tertiary"
                        height="24"
                        style="min-width:auto;"
                        :disabled="pointBalance < reward.points"
                        text
                      >
                        Redeem
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-sheet>
      </div>
    </v-sheet>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog
      v-model="dialogRedeem"
      max-width="290"
      v-if="loyaltyReward"
    >
      <v-card color="#efe6df">
        <v-card-title class="text-h6 font-weight-6 mb-1" style="word-break: normal;">
          {{ loyaltyReward.code }}
        </v-card-title>
        <v-card-text class="pb-2">
          <v-img
            class="rounded-xl"
            position="center"
            width="100%"
            :src="`${cdnUrl}/${loyaltyReward.cover}`"
          ></v-img>
          <div class="text-body-2 font-weight-6 mt-3">
            Are you sure want to redeem this voucher with <span class="text-body-1 tertiary--text font-weight-6">{{ loyaltyReward.points }} points</span>?
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="text-caption font-weight-5"
            color="disabled"
            text
            @click="dialogRedeem = false"
          >
            No
          </v-btn>

          <v-btn
            class="font-weight-bold"
            color="success darken-2"
            text
            @click="confirmRedeemLoyaltyReward()"
          >
            Yes!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-alert
      v-if="success"
      class="alert text-body-2 p-2"
      type="success"
      transition="fade-transition"
      dense
      >{{ success }}</v-alert
    >
    <v-alert
      v-if="error"
      class="alert text-body-2 p-2"
      type="error"
      transition="fade-transition"
      dense
      >{{ error }}</v-alert
    >
  </v-card>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      cdnUrl: process.env.VUE_APP_CDN_URL,
      legacyCdnUrl: process.env.VUE_APP_LEGACY_CDN_URL,
      keyword: '',
      isLoading: false,
      success: '',
      error: '',
      dialogShare: false,
      dialogRedeem: false,
      showService: false,
      loyaltyReward: null,
      services: [],
      qrCodeModal: false,
      selectedVoucher: null,
      isReloadingVouchers: false,
    };
  },
  computed: {
    ...mapState('loyalty', {
      rewards: (state) => state.rewards,
      pointBalance: (state) => state.pointBalance,
    }),
    ...mapState('merchant', {
      profile: (state) => state.profile,
    }),
    ...mapGetters('auth', {
      isLoggedIn: ['isLoggedIn'],
    }),
    ...mapGetters('cart', {
      serviceIcons: ['getServiceIcons'],
    }),
  },
  methods: {
    ...mapActions('data', ['createDataAnalyticEvent']),
    ...mapActions('loyalty', [
      'getLoyaltyRewards',
      'getLoyaltyVouchers',
      'getLoyaltyPointBalance',
      'redeemLoyaltyReward'
    ]),
    ...mapMutations('cart', ['SET_SERVICE', 'SET_VOUCHER']),
    formatDate(date) {
      return dayjs(date).format('DD MMM YYYY');
    },
    back() {
      if (this.$route.query.id || this.prevRoute?.name == 'login') {
        this.$router.push({ name: 'home' }).catch(() => {});
      } else {
        this.$router.go(-1);
      }
    },
    getVoucherPhoto(voucher) {
      if (voucher.type !== 'product') {
        return voucher.cover ? `${this.cdnUrl}/${voucher.cover}` : require(`@/assets/images/food-item-default.webp`);
      }

      return voucher.item.photo_s3 ? `${this.cdnUrl}/${voucher.item.photo_s3}` : `${this.legacyCdnUrl}/upload/${voucher.item.photo}`;
    },
    ShareThisonFB() {
      this.$gtag.event('share-facebook', {
        'event_category': 'engagement',
        'event_label': 'Share Facebook',
        'event_value': this.profile.restaurant_hostname,
      });

      this.createDataAnalyticEvent({
        event: 'share-social',
        data: {
          hqMerchantId: this.profile.hq_merchant_id,
          merchantId: this.profile.merchant_id,
          refTable: this.loyaltyCustomer ? 'loyalty_clients' : (this.customer ? 'client' : 'uuid'),
          refId: this.loyaltyCustomer?.id ?? this.customer?.phoneNo ?? localStorage.uuid,
          category: 'engagement',
          label: 'From',
          value: 'Facebook',
        },
      });

      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=https://${this.profile.restaurant_hostname}`,
        '_blank'
      );
    },
    ShareThisonTwitter() {
      this.$gtag.event('share-twitter', {
        'event_category': 'engagement',
        'event_label': 'Share Twitter',
        'event_value': this.profile.restaurant_hostname,
      });

      this.createDataAnalyticEvent({
        event: 'share-social',
        data: {
          hqMerchantId: this.profile.hq_merchant_id,
          merchantId: this.profile.merchant_id,
          refTable: this.loyaltyCustomer ? 'loyalty_clients' : (this.customer ? 'client' : 'uuid'),
          refId: this.loyaltyCustomer?.id ?? this.customer?.phoneNo ?? localStorage.uuid,
          category: 'engagement',
          label: 'From',
          value: 'Twitter',
        },
      });

      window.open(`https://twitter.com/intent/tweet`, '_blank');
    },
    ShareThisonWhatsapp() {
      this.$gtag.event('share-whatsapp', {
        'event_category': 'engagement',
        'event_label': 'Share WhatsApp',
        'event_value': this.profile.restaurant_hostname,
      });

      this.createDataAnalyticEvent({
        event: 'share-social',
        data: {
          hqMerchantId: this.profile.hq_merchant_id,
          merchantId: this.profile.merchant_id,
          refTable: this.loyaltyCustomer ? 'loyalty_clients' : (this.customer ? 'client' : 'uuid'),
          refId: this.loyaltyCustomer?.id ?? this.customer?.phoneNo ?? localStorage.uuid,
          category: 'engagement',
          label: 'From',
          value: 'WhatsApp',
        },
      });

      window.open(
        `https://api.whatsapp.com/send?text=${encodeURIComponent('Comes and grab this interesting voucher from')} https://${this.profile.restaurant_hostname}`,
        '_blank'
      );
    },
    requestRedeemLoyaltyReward(loyaltyReward) {
      if (this.pointBalance >= loyaltyReward.points) {
        this.$gtag.event('redeem-loyalty-reward', {
          event_category: 'interaction',
          event_label: `Redeem Loyalty Reward (${loyaltyReward.code})`,
          event_value: loyaltyReward,
        });

        this.createDataAnalyticEvent({
          event: 'redeem-loyalty-reward',
          data: {
            hqMerchantId: this.profile.hq_merchant_id,
            merchantId: this.profile.merchant_id,
            refTable: 'loyalty-rewards',
            refId: loyaltyReward.id,
            category: 'interaction',
          },
        });

        this.loyaltyReward = loyaltyReward;
        this.dialogRedeem = true;
      }
    },
    async confirmRedeemLoyaltyReward() {
      this.$gtag.event('confirm-redeem-loyalty-reward', {
        event_category: 'engagement',
        event_label: `Confirm Redeem Loyalty Reward (${this.loyaltyReward.code})`,
        event_value: this.loyaltyReward,
      });

      try {
        await this.redeemLoyaltyReward({
          id: this.loyaltyReward.id,
          data: {},
        });

        this.createDataAnalyticEvent({
          event: 'redeem-loyalty-reward-success',
          data: {
            hqMerchantId: this.profile.hq_merchant_id,
            merchantId: this.profile.merchant_id,
            refTable: 'loyalty-rewards',
            refId: this.loyaltyReward.id,
            category: 'engagement',
            label: 'Loyalty Client ID',
            value: this.loyaltyCustomer?.id,
          },
        });

        this.loyaltyReward = null;
        this.dialogRedeem = false;

        // Get newly redeemed voucher
        this.success = 'Thank you, you have successfully redeemed your reward!';
        this.$router.push({ name: 'vouchers' }).catch(() => {});
        setTimeout(() => this.success = '', 3000);
      } catch(e) {
        this.createDataAnalyticEvent({
          event: 'redeem-loyalty-reward-error',
          data: {
            hqMerchantId: this.profile.hq_merchant_id,
            merchantId: this.profile.merchant_id,
            refTable: 'loyalty-rewards',
            refId: this.loyaltyReward.id,
            category: 'experience',
          },
        });

        console.log(e);
        this.error = 'Something went wrong, please try again later.';
        setTimeout(() => this.error = '', 5000);
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.prevRoute = from);
  },
  async mounted() {
    // Get Loyalty Point Balance
    this.getLoyaltyPointBalance({});

    // Get Loyalty Rewards
    this.getLoyaltyRewards({
      merchantId: this.profile.merchant_id,
    })
  },
};
</script>
<style scoped>
.v-list-item__action-text {
  color: #ff6347 !important;
}
.pb-56 {
  padding-bottom: 56px !important;
}

.reward-container /deep/ .v-card {
  border: 4px solid var(--v-secondary);
}

.limited-offer {
  font-size: 8px !important;
  font-weight: 600;
  height: 18px;
  border-radius: 8px;
  color: #039be5 !important;
  background-color: rgba(3, 155, 229, 0.1) !important;
}
.limited-quantity {
  font-size: 10px !important;
  font-weight: bold;
  height: 20px;
  border-radius: 8px;
  color: #ff6347 !important;
  background-color: rgba(255, 99, 71, 0.1) !important;
}
</style>